import { FC, JSX, useCallback, useEffect, useRef, useState } from 'react'
import { makeStyles } from '@mui/styles'
import { Box, Grid, Theme, useMediaQuery } from '@mui/material'
import { YMaps, Map, Placemark, GeolocationControl, ZoomControl } from '@pbe/react-yandex-maps'
import { getPointData } from './baloon-maps'
import { img } from '../../../../imgs'
import { getMap } from '../../../../api'
import { Maps } from '../../../../types/default-types'

export const MapsSection: FC = (): JSX.Element => {
  const classes = useStyles()
  const md = useMediaQuery(({ breakpoints: { down } }: Theme) => down(1150))

  const map: any = useRef<any>({})
  const [coordinates, setCoordinates] = useState<{ map: Maps[]; phase: number }>({ map: [], phase: 0 })
  const [maps, setMaps] = useState<any>({
    zoom: md ? 4 : 5,
    center: md ? [55.755864, 37.617698] : [52.233553, 58.654845],
    behaviors: ['default', 'scrollZoom'],
  })

  const onLoadMap = (m: any) => {
    return m.geolocation.get({ provider: 'yandex', mapStateAutoApply: true }).then((result: any) => {
      m.geocode(result.geoObjects.position).then((res: any) => {
        setMaps({ ...maps, center: res.geoObjects.get(0).geometry.getCoordinates() })
      })
    })
  }

  const loadMap = useCallback(() => {
    getMap().then((res) => {
      setCoordinates(res.data)
    })
  }, [])

  useEffect(() => {
    loadMap()
  }, [])

  return (
    <Box className={classes.maps}>
      <Grid container justifyContent="center" bgcolor="#1B1B1B">
        <Grid item>
          <Box className={classes.title}>География кубка</Box>
        </Grid>
      </Grid>
      <YMaps query={{ apikey: '28f764ee-0989-429e-ab98-ba1bae10a511' }}>
        <Map
          state={maps}
          width="100%"
          instanceRef={map}
          height={md ? 400 : 600}
          // onLoad={(m) => onLoadMap(m)}
          modules={['templateLayoutFactory', 'layout.ImageWithContent', 'geolocation', 'geocode']}
        >
          <GeolocationControl />
          <ZoomControl />
          {coordinates.map.length > 0 &&
            coordinates.map.map((k: Maps, i: number) => (
              <Placemark
                key={i}
                geometry={[k.coordinates.lat, k.coordinates.lon]}
                properties={getPointData(k.activeSubdivision, k.name, k.subdivisions, coordinates.phase)}
                modules={['geoObject.addon.balloon', 'geoObject.addon.hint']}
                options={{
                  iconImageSize: [30, 42],
                  iconImageOffset: [-14, -42],
                  iconLayout: 'default#imageWithContent',
                  iconImageHref: k.activeSubdivision > 0 ? img.mapColorIcon : img.mapGreyIcon,
                }}
              />
            ))}
        </Map>
      </YMaps>
    </Box>
  )
}

const useStyles = makeStyles(({ breakpoints: { down }, palette }: Theme) => ({
  maps: {},
  title: {
    fontSize: 48,
    fontWeight: 700,
    color: '#CECECE',
    textAlign: 'center',
    textTransform: 'uppercase',
    padding: '40px 0',
    [down('lg')]: {
      fontSize: 44,
      padding: '30px 0',
    },
    [down('sm')]: {
      width: 300,
      fontSize: 32,
      padding: '20px 0',
    },
  },
}))
